import React from 'react';

import ParentIcon from 'bundles/crm/parent_icon';
import { getParentLabel, getParentPath } from 'bundles/crm/parent_helpers';

import type { Parent, ParentOption } from 'bundles/crm/types';
import type { Task } from 'bundles/apex/tasks/types';

interface Props {
  asLink?: boolean;
  currentParent?: Parent;
  options?: {
    parents?: ParentOption[];
  };
  task: Task;
}

export default function TaskParent({ asLink, currentParent, options, task }: Props) {
  const path = asLink ? getParentPath(task, { currentParent }) : null;
  let label: React.ReactNode = getParentLabel(task, { currentParent, parentOptions: options?.parents });

  if (label) {
    label = (
      <div className="d-flex align-items-center gap-2">
        <ParentIcon record={task} />
        {label}
      </div>
    );
  }

  return path ?
    <a href={path} onClick={e => e.stopPropagation()}>{label}</a> :
    <>{label}</>;
}
